import { render, staticRenderFns } from "./SellerItems.vue?vue&type=template&id=4cfc1872&scoped=true&"
import script from "./SellerItems.vue?vue&type=script&lang=js&"
export * from "./SellerItems.vue?vue&type=script&lang=js&"
import style0 from "./SellerItems.vue?vue&type=style&index=0&id=4cfc1872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc1872",
  null
  
)

export default component.exports